import PropTypes from 'prop-types';

export default PropTypes.shape({
	name: PropTypes.string,
	icon: PropTypes.string,
	label: PropTypes.string,
	description: PropTypes.string
});
